import { removeNullFieldsFromJson } from "../services/commonMethods";
import { API_ROUTES_KEY } from "./apiRoutes";

//Payload action for the apis.
export const API_ACTIONS = {
  [API_ROUTES_KEY.CHANGE_STATUS_CAMPAIGN_OFFER]: "update.campaign_status",
  [API_ROUTES_KEY.GET_CASH_ORDER]: "get.cash_order",
  [API_ROUTES_KEY.GET_CASH_ORDER_DETAILS]: "get.cash_order_breakup",
  [API_ROUTES_KEY.GET_TALLY_ORDER]: "get.tally_order",
  [API_ROUTES_KEY.CHANGE_SUPPLIER_EMAIL]: "update.supplier_email",
  [API_ROUTES_KEY.RECEIVE_PURCHASE_ORDER]: "receive.direct_purchase_order",
  [API_ROUTES_KEY.GET_TALLY_INVENTORY]: "get.tally_inventory_order",
  [API_ROUTES_KEY.GET_TALLY_INVENTORY_CATEGORY_LIST]: "list.inventory_category",
  [API_ROUTES_KEY.GET_MATERIAL_TRANSFER]: "get.material_transfer",
  [API_ROUTES_KEY.GET_TALLY_INVENTORY_BRAND_LIST]: "list.inventory_brand",
  [API_ROUTES_KEY.CREATE_TALLY_INVENTORY_ORDER]: "create.order",
  [API_ROUTES_KEY.STORE_STORE_RETURN_ORDER_OVERVIEW]: "get.store_return_order",
  [API_ROUTES_KEY.DELETE_STORE_RETURN_ORDER]: "delete.store_return_order",
  [API_ROUTES_KEY.EDIT_VENDING_MACHINE]: "edit.vending_machine",
  [API_ROUTES_KEY.VENDING_MACHINE_TAGS]: "list.vending_machine_tag",
  [API_ROUTES_KEY.LINK_HARDWARE_BOARD]: "link.hardware_board",
  [API_ROUTES_KEY.GET_VM_LIST_BY_HARDWARE_BOARD]:
    "list.vending_machines_by_hardware_board",
  [API_ROUTES_KEY.GET_VM_LIST_BY_PLANOGRAM]: "list.vm_by_planogram_template",
  [API_ROUTES_KEY.GET_PLANOGRAM_LIST_BY_VM_TEMPLATE]:
    "list.planogram_template_by_vm_template",
  [API_ROUTES_KEY.CHANGE_MULTIPLE_TEMPLATE]: "change.multiple_machine_template",
  [API_ROUTES_KEY.ISSUE_REPORTER]: "report_issue",
  [API_ROUTES_KEY.GET_USER_LIST]: "list.users",
  [API_ROUTES_KEY.GET_ADMINS_LIST]: "list.admins",
  [API_ROUTES_KEY.LIST_ZONES]: "list.zones",
  [API_ROUTES_KEY.DELETE_ZONES]: "delete.zone",
  [API_ROUTES_KEY.GET_PRODUCT]: "get.product",
  [API_ROUTES_KEY.DELETE_PRODUCT]: "delete.product",
  [API_ROUTES_KEY.LIST_WAREHOUSES]: "list.warehouses",
  [API_ROUTES_KEY.CREATE_WAREHOUSES]: "create.warehouse",
  [API_ROUTES_KEY.UPDATE_WAREHOUSES]: "update.warehouse",
  [API_ROUTES_KEY.GET_VENDING_MACHINE]: "get_detailed.vm",
  [API_ROUTES_KEY.GET_DELETED_VENDING_MACHINE]: "get_deleted.vm",
  [API_ROUTES_KEY.GET_VENDING_MACHINE_FEEDBACK]: "get.vm_feedback",
  [API_ROUTES_KEY.GET_STORE_INVENTORY]: "list.store_inventory",
  [API_ROUTES_KEY.GET_WAREHOUSE_INVENTORY]: "list.inventory",
  [API_ROUTES_KEY.CREATE_SAVED_REPORT]: "create.saved_report",
  [API_ROUTES_KEY.GET_SAVED_SALES_TEMPLATE]: "list.saved_report",
  [API_ROUTES_KEY.GET_SAVED_SALES_REPORT]: "get.saved_report",
  [API_ROUTES_KEY.GET_DEFAULT_SALES_TEMPLATE]: "list.default_saved_report",
  [API_ROUTES_KEY.GET_PRODUCT_PACKAGING_LIST]: "list.packaging",
  [API_ROUTES_KEY.GET_PRODUCT_STATUS_LIST]: "list.product_statuses",
  [API_ROUTES_KEY.GET_PRODUCT_TYPE_LIST]: "list.product_type",
  [API_ROUTES_KEY.CREATE_PRODUCT]: "create.product",
  [API_ROUTES_KEY.UPDATE_PRODUCT]: "update.product",
  [API_ROUTES_KEY.GET_REQUESTED_PRODUCT]: "get.request_product",
  [API_ROUTES_KEY.GET_PRODUCT_SHELF_LIFE_LIST]: "list.shelf_life",
  [API_ROUTES_KEY.LIST_SHIPPING_WAREHOUSES]: "shipping.list.warehouses",
  [API_ROUTES_KEY.DELETE_WAREHOUSE]: "delete.warehouse",
  [API_ROUTES_KEY.GET_USER_PRODUCT_CATEGORY_LIST]: "list.product_categories",
  [API_ROUTES_KEY.GET_PRODUCT_UNIT_LIST]: "list.product_units",
  [API_ROUTES_KEY.GET_PRODUCT_BRAND_LIST]: "list.brands",
  [API_ROUTES_KEY.LIST_DS1_BRANDS]: "ds1.list_brands",
  [API_ROUTES_KEY.LIST_DS1_PRODUCT_CATALOGUES]: "ds1.list_product_catalogues",
  [API_ROUTES_KEY.LIST_DS1_PRODUCTS_BY_CATALOGUE]: "ds1.list_products_by_catalogue_key",
  [API_ROUTES_KEY.GET_DS1_PRODUCT_FILTERS]: "ds1.get_products_by_catalogue_filters",
  [API_ROUTES_KEY.SYNC_DS1_PRODUCTS]: "ds1.sync_products",
  [API_ROUTES_KEY.LIST_DS1_ALL_PRODUCTS]: "ds1.list_ds1_products",
  [API_ROUTES_KEY.GET_DS1_ALL_PRODUCT_FILTERS]: "ds1.get_ds1_product_list_filters",
  [API_ROUTES_KEY.GET_DS1_PRODUCT_VARIANT_OVERVIEW]: "ds1.get_product_overview",
  [API_ROUTES_KEY.ARCHIVE_DS1_PRODUCT_VARIANT]: "archive.product",
  [API_ROUTES_KEY.SYNC_DS1_FULL_CATALOGUE]: "ds1.sync_full_catalogue",
  [API_ROUTES_KEY.PRODUCT_BRAND_LIST_FOR_FILTER]: "list.brand_names",
  [API_ROUTES_KEY.DELETE_PRODUCT_CATAGORY]: "delete.product_category",
  [API_ROUTES_KEY.DOWNLOAD_TRANSACTIONS_HISTORY]: "download.orders",
  [API_ROUTES_KEY.GET_SUPPLIER_LIST]: "list.suppliers",
  [API_ROUTES_KEY.CREATE_SUPPLIER]: "create.supplier",
  [API_ROUTES_KEY.UPDATE_SUPPLIER]: "update.supplier",
  [API_ROUTES_KEY.GET_SUPPLIER]: "get.supplier",
  [API_ROUTES_KEY.DELETE_SUPPLIER]: "delete.supplier",
  [API_ROUTES_KEY.GET_PRODUCT_LIST]: "list.products",
  [API_ROUTES_KEY.CREATE_PURCHASE_ORDER]: "create.purchase_order",
  [API_ROUTES_KEY.GET_PURCHASE_ORDER_LIST]: "list.purchase_orders",
  [API_ROUTES_KEY.GET_PURCHASE_ORDER]: "get.purchase_order",
  [API_ROUTES_KEY.UPDATE_PURCHASE_ORDER]: "update.purchase_order",
  [API_ROUTES_KEY.MANAGE_PURCHASE_ORDER]: "manage.purchase_order",
  [API_ROUTES_KEY.DELETE_PURCHASE_ORDER]: "delete.purchase_order",
  [API_ROUTES_KEY.GET_WAREHOUSE_LIST]: "list.warehouses",
  [API_ROUTES_KEY.GET_SUPPLIER_LIST_BY_PRODUCT_IDS]:
    "list.suppliers_and_price_info",
  [API_ROUTES_KEY.GET_PRICE_AND_QUANTITY_BY_SUPPLIER]:
    "get.price_and_quantity_info",
  [API_ROUTES_KEY.UPDATE_PURCHASE_ORDER]: "update.purchase_order",
  [API_ROUTES_KEY.GET_COMPANY_INVENTORY_ACTIVE_PRODUCTS]: "list.inventory2",
  [API_ROUTES_KEY.GET_COMPANY_INVENTORY_MAPPED_WITH_SUPPLIERS]:
    "list.products_for_company",
  [API_ROUTES_KEY.GET_STORE_INVENTORY_ACTIVE_PRODUCTS]: "list.store_inventory2",
  [API_ROUTES_KEY.UPDATE_RUNOUT_AND_MAX_QTY]: "update.runout_and_max_qty",
  [API_ROUTES_KEY.LIST_STORE_AND_WAREHOUSE_INVENTORY]:
    "list.store_and_warehouse_inventory",
  [API_ROUTES_KEY.GET_STORE_MANAGER_LIST]: "list.store_manager",
  [API_ROUTES_KEY.CREATE_STORE_MANAGER]: "create.store_manager",
  [API_ROUTES_KEY.UPDATE_STORE_MANAGER]: "update.store_manager",
  [API_ROUTES_KEY.DELETE_STORE_MANAGER]: "delete.store_manager",
  [API_ROUTES_KEY.GET_STORE_MANAGER]: "get.store_manager",
  [API_ROUTES_KEY.GET_STORE_LIST]: "list.stores",
  [API_ROUTES_KEY.UPDATE_STORE_MANAGER]: "update.store_manager",
  [API_ROUTES_KEY.DELETE_STORE_MANAGER]: "delete.store_manager",
  [API_ROUTES_KEY.GET_VM_TEMPLATE_LIST]: "list.vm_template",
  [API_ROUTES_KEY.GET_VM_TEMPLATE_NAME_LIST]: "list.vm_template_minimal",
  [API_ROUTES_KEY.CREATE_VM_TEMPLATE]: "create.vm_template",
  [API_ROUTES_KEY.GET_VM_TEMPLATE]: "get.vm_template",
  [API_ROUTES_KEY.UPDATE_VM_TEMPLATE]: "update.vm_template",
  [API_ROUTES_KEY.DELETE_VM_TEMPLATE]: "delete.vm_template",
  [API_ROUTES_KEY.GET_STORE_MANAGER_BY_STORE_ID]:
    "get.store_manager_by_store_id",
  [API_ROUTES_KEY.GET_BULK_REFILL_LIST]: "list.bulk_refill",
  [API_ROUTES_KEY.GET_BULK_REFILL]: "get.bulk_refill",
  [API_ROUTES_KEY.CREATE_BULK_REFILL]: "create.bulk_refill",
  [API_ROUTES_KEY.UPDATE_BULK_REFILL]: "update.bulk_refill",
  [API_ROUTES_KEY.DELETE_BULK_REFILL]: "delete.bulk_refill",
  [API_ROUTES_KEY.CREATE_REFILL]: "create.refill",
  [API_ROUTES_KEY.UPDATE_REFILL]: "update.refill",
  [API_ROUTES_KEY.ASSIGN_DP_TO_REFILL_IN_BULK_REFILL]: "update.delivery_person",
  [API_ROUTES_KEY.GET_DELIVERY_PERSON_LIST]: "list.delivery_person",
  [API_ROUTES_KEY.GET_REFILL_PARTNER_LIST]: "list.refill_partner",
  [API_ROUTES_KEY.GET_TECHNICIAN_PARTNER_LIST]: "list.technician",
  [API_ROUTES_KEY.GET_STORE_MANAGER_AND_DELIVERY_PERSON_LIST]:
    "list.store_manager_and_delivery_person",
  [API_ROUTES_KEY.CREATE_SETTINGS_TEMPLATE]: "create.settings_template",
  [API_ROUTES_KEY.UPDATE_SETTINGS_TEMPLATE]: "update.settings_template",
  [API_ROUTES_KEY.GET_SETTINGS_TEMPLATE_LIST]: "list.settings_template",
  [API_ROUTES_KEY.GET_SETTINGS_TEMPLATE]: "get.settings_template",
  [API_ROUTES_KEY.DELETE_SETTINGS_TEMPLATE]: "delete.settings_template",
  [API_ROUTES_KEY.GET_CARRIER_BOARD_LIST]: "list.vendify_carrier_board",
  [API_ROUTES_KEY.GET_VM_BRAND_MODEL_LIST]:
    "list.vending_machine_brand_and_model",
  [API_ROUTES_KEY.GET_VM_TYPE_LIST]: "list.vending_machine_type",
  [API_ROUTES_KEY.GET_NETWORK_DEVICE_TYPE_LIST]: "list.network_device_types",
  [API_ROUTES_KEY.UNLOCK_VM]: "unlock.vm",
  [API_ROUTES_KEY.GET_TRANSACTION_REPORT_COLUMNS]:
    "get.transaction_report_columns",
  [API_ROUTES_KEY.GET_USER_SAVED_COLUMNS]: "get.user_saved_report_columns",
  [API_ROUTES_KEY.GET_USER]: "get.user",
  [API_ROUTES_KEY.BLOCK_UNBLOCK_VM_COLUMN]: "update.vm_motor_block_status",
  [API_ROUTES_KEY.GET_FINANCE_REPORT]: "download.finance_report",
  [API_ROUTES_KEY.GET_REFUND_REASON_LIST]: "list.refund_reason",
  [API_ROUTES_KEY.GET_REFUNDABLE_ITEMS_LIST]: "get.refund_item_list",
  [API_ROUTES_KEY.INITIATE_REFUND]: "initiate_refund.order",
  [API_ROUTES_KEY.DELETE_USER]: "delete.user",
  [API_ROUTES_KEY.CREATE_USER]: "create.user",
  [API_ROUTES_KEY.UPDATE_USER]: "update.user",
  [API_ROUTES_KEY.FRANCHISE_LIST]: "list.franchises",
  [API_ROUTES_KEY.USER_ROLES]: "list.roles",
  [API_ROUTES_KEY.DELETE_BRAND]: "delete.brand",
  [API_ROUTES_KEY.DELETE_PRODUCT_UNIT]: "delete.product_unit",
  [API_ROUTES_KEY.DELETE_PRODUCT_PACKAGING]: "delete.packaging",
  [API_ROUTES_KEY.LIST_DELIVERY_PARTNERS]: "list.delivery_partners",
  [API_ROUTES_KEY.DELETE_DELIVERY_PARTNER]: "delete.delivery_partner",
  [API_ROUTES_KEY.DELETE_FRANCHISE]: "delete.franchise",
  [API_ROUTES_KEY.DELETE_STORE]: "delete.store",
  [API_ROUTES_KEY.GET_STATES_LIST]: "list.states",
  [API_ROUTES_KEY.GET_STATE_LIST_BY_COUNTRY]: "list.states_by_country",
  [API_ROUTES_KEY.GET_COUNTRIES_LIST]: "list.countries",
  [API_ROUTES_KEY.GET_STORE]: "get.store",
  [API_ROUTES_KEY.GET_STATE]: "get.state",
  [API_ROUTES_KEY.SHIPPING_LIST]: "list.shippings",
  [API_ROUTES_KEY.DELETE_SHIPPING]: "delete.shipping",
  [API_ROUTES_KEY.DELETE_DELIVERY_PERSON]: "delete.delivery_person",
  [API_ROUTES_KEY.DELETE_REFILL_PARTNER]: "delete.refill_partner",
  [API_ROUTES_KEY.GET_VENDING_MACHINE_LIST]: "list.available_vms",
  [API_ROUTES_KEY.GET_VENDING_MACHINE_CONFIGURED_LIST]: "list.configured_vms",
  [API_ROUTES_KEY.UPDATE_VM_STATUS]: "update_status.vm",
  [API_ROUTES_KEY.DELETE_VM]: "delete.vm",
  [API_ROUTES_KEY.ORDER_LIST]: "list.orders",
  [API_ROUTES_KEY.LIST_APPLICABLE_STATES]: "list.applicable_states",
  [API_ROUTES_KEY.LIST_APPLICABLE_CITIES]: "list.applicable_cities",
  [API_ROUTES_KEY.LIST_DISCOUNT]: "campaign.list",
  [API_ROUTES_KEY.CREATE_PLANOGRAM_TEMPLATE]: "create.planogram_template",
  [API_ROUTES_KEY.PLANOGRAM_LIST]: "list.planogram_template",
  [API_ROUTES_KEY.GET_PLANOGRAM_TEMPLATE]: "get.planogram_template",
  [API_ROUTES_KEY.DELETE_PLANOGRAM]: "delete.planogram_template",
  [API_ROUTES_KEY.GET_RETURN_ORDER]: "get.return_order",
  [API_ROUTES_KEY.GET_AVAILABLE_PRODUCT]: "list.products_by_store_or_warehouse",
  [API_ROUTES_KEY.GET_HARDWARE_BOARD_LIST]: "list.hardware_boards",
  [API_ROUTES_KEY.DELETE_HARDWARE]: "delete.hardware_board",
  [API_ROUTES_KEY.VM_MAINTENANCE]: "toggle.maintenance_mode",
  [API_ROUTES_KEY.DELETED_VM_LIST]: "list.deleted_vending_machines",
  [API_ROUTES_KEY.DISABLE_VENDING_MACHINE]: "disable.vending_machine",
  [API_ROUTES_KEY.ENABLE_VENDING_MACHINE]: "enable.vending_machine",
  [API_ROUTES_KEY.LIST_REFILLS]: "list.refills",
  [API_ROUTES_KEY.LIST_RETURN_ORDERS]: "list.return_order",
  [API_ROUTES_KEY.LIST_STORE_RETURN_ORDERS]: "list.store_return_order",
  [API_ROUTES_KEY.DELETE_REFILL]: "delete.refill",
  [API_ROUTES_KEY.DELETE_RETURN_ORDER]: "delete.return_order",
  [API_ROUTES_KEY.GET_REFILL]: "get.refill",
  [API_ROUTES_KEY.GET_TOPUP]: "get.refill_top_up",
  [API_ROUTES_KEY.STORE_STORE_RETURN_ORDER]: "list.store_return_order",
  [API_ROUTES_KEY.STORE_VM_RETURN_ORDER]: "list.return_order",
  [API_ROUTES_KEY.GET_STORE_RETURN_ORDERS]: "get.store_return_order",
  [API_ROUTES_KEY.DELETE_STORE_RETURN_ORDERS]: "delete.store_return_order",
  [API_ROUTES_KEY.GET_BRAND_LIST]: "list.brand_names",
  [API_ROUTES_KEY.ORDER_LIST_BY_ORDER_ID]: "search.order_by_order_id",
  [API_ROUTES_KEY.PRODUCT_CATEGORY_LIST_FOR_FILTER]:
    "list.product_category_names",
  [API_ROUTES_KEY.PRODUCT_BRAND_LIST_FOR_FILTER]: "list.brand_names",
  [API_ROUTES_KEY.GET_REPORT_LIST]: "list.finance_report_request",
  // Retailers management
  [API_ROUTES_KEY.ADD_RETAILER]: "add.retailer",
  [API_ROUTES_KEY.UPDATE_RETAILER]: "edit.retailer",
  [API_ROUTES_KEY.GET_RETAILER_LIST]: "list.retailers",
  [API_ROUTES_KEY.DELETE_RETAILER]: "delete.retailer",
  [API_ROUTES_KEY.GET_RETAILER]: "get.retailer",
  [API_ROUTES_KEY.WAREHOUSE_STOCK_LIST]: "list.inventory",
  [API_ROUTES_KEY.WAREHOUSES_ORDERS_LIST]: "list.warehouse_orders",
  [API_ROUTES_KEY.LIST_PARAMETERS_WAREHOUSE_ORDERS]:
    "list.parameters.warehouse_orders",
  [API_ROUTES_KEY.GET_ACKNOWLEDGE_REFILL]: "ack.refill",
  [API_ROUTES_KEY.EXECUTE_SUPPLIER_RETURN]: "execute.supplier_return",
  [API_ROUTES_KEY.DELETE_SUPPLIER_RETURN]: "delete.supplier_return",
  [API_ROUTES_KEY.DELETE_VM_REFILLS]: "delete.vm_refills",
  [API_ROUTES_KEY.RECEIVE_VM_RETURN_ORDER]: "receive.vm.return_order",
  [API_ROUTES_KEY.EXECUTE_MATERIAL_TRANSFER]: "execute.material_transfer",
  [API_ROUTES_KEY.EXECUTE_INTRANSIT_MATERIAL_TRANSFER]:
    "execute.intransit_material_transfer",
  [API_ROUTES_KEY.EXECUTE_REQUEST_ORDER]: "execute.request_order",
  [API_ROUTES_KEY.GET_APPROVAL_REQUEST_ORDER]: "get.approval_request_order",
  [API_ROUTES_KEY.RECEIVE_STORE_RETURN_ORDER]: "receive.store_return_order",
  [API_ROUTES_KEY.LIST_PARAMETERS_WAREHOUSES]: "list.parameters.warehouses",
  [API_ROUTES_KEY.LIST_PARAMETERS_TECHNICIAN]: "list.parameters.technician",
  [API_ROUTES_KEY.LIST_PARAMETERS_WAREHOUSE_STOCK]: "list.parameters.stock",
  [API_ROUTES_KEY.LIST_INVENTORY]: "list.inventory",
  [API_ROUTES_KEY.GET_WAREHOUSE]: "get.warehouse",
  [API_ROUTES_KEY.LIST_PARAMETERS_SHIPPING_CREATE]:
    "list.parameters.shipping_create",
  [API_ROUTES_KEY.GET_SHIPPING]: "get.shipping",
  [API_ROUTES_KEY.UPDATE_SHIPPING]: "update.shipping",
  [API_ROUTES_KEY.GET_FILTER_MODE_PARAMETER]: "list.order_status_parameters",
  [API_ROUTES_KEY.GET_CUSTOMER_FEEDBACK_LIST]: "list.customer.feedback",
  [API_ROUTES_KEY.DOWNLOAD_FEEDBACK_HISTORY]: "download.feedbacks",
  [API_ROUTES_KEY.GET_ADVERTISEMENT_LIST]: "list.advertisement",
  [API_ROUTES_KEY.DELETE_ADVERTISEMENT]: "delete.advertisement",
  [API_ROUTES_KEY.GET_DAY_DATE_WISE_SALES_DATA]:
    "get.day_date_wise_sales_analytics",
  [API_ROUTES_KEY.GET_HOUR_WISE_SALES_DATA]: "get.hour_wise_sales_analytics",
  [API_ROUTES_KEY.GET_TOP_FAILURE_VM_DATA]: "get.top_failure_vending_machines",
  [API_ROUTES_KEY.GET_TOP_SELLING_PRODUCTS]: "get.top_selling_products_by_vm",
  [API_ROUTES_KEY.GET_TOP_SELLING_BRANDS]: "get.top_selling_brands_by_vm",
  [API_ROUTES_KEY.GET_REVENUE_VM_DATA]: "get.sales_vm_analytics",
  [API_ROUTES_KEY.DOWNLOAD_REFILL_ORDER_REPORT]: "download.refill_orders",
  [API_ROUTES_KEY.DOWNLOAD_REQUEST_ORDER_REPORT]: "download.requested_products",
  [API_ROUTES_KEY.EDIT_LINK_REFILL_PARTNERS]: "link.refill_partners",
  [API_ROUTES_KEY.CREATE_REFILL_PARTNERS]: "create.refill_partner",
  [API_ROUTES_KEY.UPDATE_REFILL_PARTNERS]: "update.refill_partner",
  [API_ROUTES_KEY.CREATE_TECHNICIAN_PARTNERS]: "create.technician",
  [API_ROUTES_KEY.UPDATE_TECHNICIAN_PARTNERS]: "update.technician",
  [API_ROUTES_KEY.GET_TECHNICIAN_PARTNER]: "get.technician",
  [API_ROUTES_KEY.GET_REFILL_PARTNERS]: "get.refill_partner",
  [API_ROUTES_KEY.LINK_REFILL_PARTNERS]: "link.refill_partners",
  [API_ROUTES_KEY.EDIT_LINK_WAREHOUSE_MANAGERS]: "link.warehouse_managers",
  [API_ROUTES_KEY.EDIT_LINK_WAREHOUSE_FOR_WM]: "link.warehouses",
  [API_ROUTES_KEY.LINK_WAREHOUSE_FOR_WM]: "link.warehouses",
  [API_ROUTES_KEY.GET_CUSTOMER_PLATFORM_LIST]: "list.customer_platforms",
  [API_ROUTES_KEY.GET_PLATFORM_LINKED_VMList]: "list.vending_machines",
  [API_ROUTES_KEY.GET_RESTRICTED_PRODUCT_LIST]: "list.products",
  [API_ROUTES_KEY.LINK_VENDING_MACHINES]: "link.vending_machines",
  [API_ROUTES_KEY.LINK_VENDING_MACHINES_TECHNICIAN]: "link.vending_machines_technician",
  [API_ROUTES_KEY.LINK_WAREHOUSES]: "link.warehouses",
  [API_ROUTES_KEY.LINK_WAREHOUSES_TECHICIAN]: "linkable.warehouses_technician",
  [API_ROUTES_KEY.TECHNICIAN_TRANSACTION_LIST]: "tech.transaction_list",
  [API_ROUTES_KEY.LINK_VEHICLES]: "link.vehicles",
  [API_ROUTES_KEY.GET_NEGATIVE_ITEMS_LIST]: "list.negative_items",
  [API_ROUTES_KEY.GET_NEGATIVE_ITEM]: "get.negative_item",
  [API_ROUTES_KEY.DELETE_NEGATIVE_ITEM]: "delete.negative_item",
  [API_ROUTES_KEY.LINK_ITEMS]: "link.products",
  [API_ROUTES_KEY.LINK_VENDING_MACHINES_NEGATIVE_ITEM]: "link.vending_machines",
  [API_ROUTES_KEY.CHANGE_STATUS_REFILL_PARTNER]: "update.refill_partner_status",
  [API_ROUTES_KEY.CHANGE_PIN_REFILL_PARTNER]: "change.refill_partner_pin",
  [API_ROUTES_KEY.CREATE_REQUEST_PRODUCT]: "create.request_product",
  [API_ROUTES_KEY.EDIT_REQUEST_PRODUCT]: "update.request_product",
  [API_ROUTES_KEY.LINK_REFILLER_PERMISSION]: "link.refiller_permissions",
  [API_ROUTES_KEY.LINK_REFILLER_NOTIFICATION]: "link.refiller_notifications",
  [API_ROUTES_KEY.CREATE_KIT_TRANSFER]: "create.kit_transfer",
  [API_ROUTES_KEY.GET_VEHICLE_LIST]: "list.vehicles",
  [API_ROUTES_KEY.GET_LITE_WAREHOUSE_LIST]: "list.warehouses_names",
  [API_ROUTES_KEY.GET_DIRECT_SALES]: "get.direct_sales",
  [API_ROUTES_KEY.GET_LIST_DIRECT_SALES]: "list.direct_sales",
  [API_ROUTES_KEY.GET_DIRECT_SALES_PARAMETERS]: "list.direct_sale_parameters",
  [API_ROUTES_KEY.GET_VENDING_MACHINE_NAMES]: "list.vending_machine_names",
  [API_ROUTES_KEY.GET_ACTIVE_VENDING_MACHINE_RAW_LIST]:
    "list.active_vending_machines_raw",
  [API_ROUTES_KEY.GET_ACTIVE_VENDING_MACHINE_LIST]:
    "list.active_vending_machines",
  [API_ROUTES_KEY.GET_ADVERTISEMENT]: "get.advertisement",
  [API_ROUTES_KEY.ADD_ADVERTISMENT]: "add.advertisement",
  [API_ROUTES_KEY.EDIT_ADVERTISMENT]: "edit.advertisement",
  [API_ROUTES_KEY.GET_CASH_IN_HAND_ORDER]: "get.cash_in_hand_order",
  [API_ROUTES_KEY.RECEIVE_CASH_IN_HAND_ORDER]: "receive.cash_in_hand_order",
  [API_ROUTES_KEY.GET_FRANCHISE_ANALYTICS]: "get.franchise_analytics",
  [API_ROUTES_KEY.GET_TOP_BRANDS]: "get.top_brands",
  [API_ROUTES_KEY.GET_RETAILER_ANALYTICS]: "get.retailer_analytics",
  [API_ROUTES_KEY.GET_TOP_PRODUCTS]: "get.top_products",
  [API_ROUTES_KEY.GET_VM_ANALYTICS]: "get.vm_analytics",
  [API_ROUTES_KEY.GET_DELIVERY_PARTNER]: "get.delivery_partner",
  [API_ROUTES_KEY.CREATE_DELIVERY_PARTNER]: "create.delivery_partner",
  [API_ROUTES_KEY.UPDATE_DELIVERY_PARTNER]: "update.delivery_partner",
  [API_ROUTES_KEY.CREATE_DELIVERY_PERSON]: "create.delivery_person",
  [API_ROUTES_KEY.GET_DELIVERY_PERSON]: "get.delivery_person",
  [API_ROUTES_KEY.GET_FRANCHISE]: "get.franchise",
  [API_ROUTES_KEY.CREATE_FRANCHISE]: "create.franchise",
  [API_ROUTES_KEY.UPDATE_FRANCHISE]: "update.franchise",
  [API_ROUTES_KEY.GET_PRODUCTS_WITH_WH_STOCK_LIST]:
    "list.products_with_wh_stock",
  [API_ROUTES_KEY.GET_UPDATED_INVENTORY_LIST]: "update.inventory",
  [API_ROUTES_KEY.GET_STOCK_AVAILABILITY]: "stock_availability",
  [API_ROUTES_KEY.GET_KIT_TRANSFER]: "get.kit_transfer",
  [API_ROUTES_KEY.GET_VM_PARAMETERS_LIST]: "list.vm_parameters",
  [API_ROUTES_KEY.GET_LINKABLE_VENDING_MACHINES]: "linkable.vending_machines",
  [API_ROUTES_KEY.CREATE_NEGATIVE_ITEMS]: "create.negative_item",
  [API_ROUTES_KEY.UPDATE_NEGATIVE_ITEMS]: "update.negative_item",
  [API_ROUTES_KEY.GET_NOTIFICATION_LIST]: "list.notifications",
  [API_ROUTES_KEY.GET_NOTIFICATION_COUNT]: "count.notifications",
  [API_ROUTES_KEY.GET_PRODUCT_FEEDBACK]: "get.product_feedback",
  [API_ROUTES_KEY.GET_PRODUCT_REQUESTS]: "list.product_requests",
  [API_ROUTES_KEY.DELETE_PRODUCT_REQUESTS]: "delete.product_request",
  [API_ROUTES_KEY.GET_REFILL_PARTNERS_LIST]: "list.refill_partners_list",
  [API_ROUTES_KEY.GET_LINKABLE_WAREHOUSES]: "linkable.warehouses",
  [API_ROUTES_KEY.CREATE_VENDING_MACHINE]: "create.vending_machine",
  [API_ROUTES_KEY.GET_VM_TEMPLATE_MODELS]: "list.models",
  [API_ROUTES_KEY.GET_MANUFACTURERS]: "list.manufacturers",
  [API_ROUTES_KEY.GET_DISCOUNT]: "get.campaign",
  [API_ROUTES_KEY.GET_PURCHASE_RETURN_LIST]: "get.purchase.return.list",
  [API_ROUTES_KEY.EDIT_MATERIAL_TRANSFER]: "update.material_transfer",
  [API_ROUTES_KEY.GET_ALL_REPORT_LIST]: "list.report_list",
  [API_ROUTES_KEY.GET_REPORT]: "get.report",
  [API_ROUTES_KEY.GET_LIST_OF_MASTER_CONFIG]: "list.master_config",
  [API_ROUTES_KEY.GET_INCIDENT_LIST]: "list.technician_incidents",
  [API_ROUTES_KEY.INCIDENT_FILTER_PARAMETERS]: "list.incident_filter_parameters",
  [API_ROUTES_KEY.GET_INCIDENT_TYPE_LIST]: "list.technician_incident_type",
  [API_ROUTES_KEY.GET_JOB_LIST]: "list.technician_jobs",
  [API_ROUTES_KEY.MOTOR_ACTION_LOGS]: "list.technician_action_logs",
  [API_ROUTES_KEY.TECHNICIAN_LOGS]: "list.technician_action_logs",
};

//Function returns payload data in required format.
export const getPayloadData = (
  apiUniqueKey,
  removeNullFields = false,
  restParameters = {}
) => {
  // API_ROUTES_KEY.GET_LIST_OF_MASTER_CONFIG
  let action = API_ACTIONS[apiUniqueKey];
  //data to be returned.
  if (removeNullFields) {
    removeNullFieldsFromJson(restParameters);
  }

  return {
    payload: {
      action,
      ...restParameters,
    },
  };
};
